import React from "react";
import "./about.css"; // Import the CSS file
import Header from "../Header"; // Assuming this is your pre-built Header component
import Footer from "../Footer"; // Assuming this is your pre-built Footer component
import { Box, Typography } from "@mui/material";

const Motivation = () => {
  const sections = [
    {
      image: "Images/About/mot1.jpg",
      text: "The foundation of JAMIA NIDA-E-ISLAM is deeply rooted in the belief that education is not just a pathway to success but a transformative force capable of uplifting individuals and communities. Inspired by the timeless value of knowledge and the powerful notion that 'Knowledge is Light,' the institution was established with the vision of bridging the gap between education and societal growth. Its motivation stems from the desire to create a space where children can learn, grow, and thrive while being nurtured in an environment that values compassion, integrity, and service.",
    },
    {
      image: "Images/About/mot2.png",
      text: "The idea for JAMIA NIDA-E-ISLAM was shaped by a profound understanding of the challenges faced by many communities—particularly the need for accessible and holistic education that not only empowers children academically but also prepares them to make meaningful contributions to society. The school draws inspiration from the belief that every child deserves an opportunity to shine and that education is the most powerful tool for breaking cycles of poverty and inequity.",
    },
    {
      image: "Images/About/mot3.png",
      text: "The motivation to combine education with social service comes from the awareness that true learning extends beyond textbooks. The founders of JAMIA NIDA-E-ISLAM envisioned a school where students could develop into well-rounded individuals—academically skilled, morally strong, and socially conscious. Their inspiration lies in creating a balance between the pursuit of personal success and the fulfillment of societal obligations.",
    },
    {
      image: "Images/About/mot4.png",
      text: "JAMIA NIDA-E-ISLAM continues to be inspired by the resilience of those it serves and the potential of every child to make a difference. By nurturing young minds and empowering them with the tools to succeed, the institution seeks to honor its foundational vision and carry forward the legacy of using education as a force for good.",
    },
  ];

  return (
    <div className="about-education">
      <Header />
      <main className="content">
        {/* Hero Section */}
        <section className="hero">
          <img
            src="Images/About/header.png"
            alt="Background"
            className="hero-image"
          />
          <div className="overlay">
            <h1 className="title">Motivation</h1>
          </div>
        </section>

        {/* Content Section */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
            padding: "16px",
            marginLeft: { xs: "auto", md: "50px" },
            marginRight: { xs: "auto", md: "50px" },
          }}
        >
          {sections.map((section, index) => (
            <Box
              key={index}
              sx={{
                display: "flex",
                flexDirection: {
                  xs: "column",
                  md: index % 2 === 0 ? "row" : "row-reverse",
                },
                gap: 3,
                alignItems: "center",
                padding: "16px",
                backgroundColor: "#f9f9f9",
                borderRadius: "8px",
                boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
              }}
            >
              <Box
                component="img"
                src={section.image}
                alt={`Section ${index}`}
                sx={{
                  flex: 1,
                  width: "100%",
                  height: "auto",
                  borderRadius: "8px",
                  boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                  maxWidth: { md: "25%" },
                }}
              />
              <Typography
                variant="body1"
                sx={{
                  flex: 1,
                  fontSize: "1.1rem",
                  textAlign: "justify",
                  color: "#555",
                }}
              >
                {section.text}
              </Typography>
            </Box>
          ))}
        </Box>
      </main>
      <Footer />
    </div>
  );
};

export default Motivation;
